import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

export const Treatment = props => {
  return (
        <span
          style={{ display: "inline" }}
          dangerouslySetInnerHTML={{
            __html: _.setSEOVariables(
              props.drug.treatment,
              props.lowestPrice,
              props.replaceableVariables
            )
          }}
        ></span>
  );
};

Treatment.propTypes = {
  drug: PropTypes.object,
  doNotMarket: PropTypes.bool,
  lowestPrice: PropTypes.any,
  replaceableVariables: PropTypes.object
};

Treatment.defaultProps = {
  drug: { Name: "" },
  doNotMarket: false,
  lowestPrice: 0,
  replaceableVariables: {
    priceUsualAndCustomary: 0,
    qty: 0,
    dosage: "",
    form: ""
  }
};

export default Treatment;
